// extracted by mini-css-extract-plugin
export default {"icon":"JumpToExternalForm-sfeqf__icon","jumpStyling":"JumpToExternalForm-+c22I__jumpStyling","multipleJumpsWrapper":"JumpToExternalForm-qEBtM__multipleJumpsWrapper"};